let base_url = "https://prm.chinacaring.com";

if (
  !location.origin.includes("chinacaring") &&
  process.env.NODE_ENV !== "development"
) {
  base_url = location.origin;
} else if (location.origin.includes("1000.chinacaring")) {
  base_url = location.origin;
} else {
  base_url = base_url;
}
if (process.env.VUE_APP_PATH && (process.env.VUE_APP_PATH !== " ".trim()) && (process.env.VUE_APP_PATH !== ("CARING_1_API_PATH".split("_1").join("")))) {
  base_url = process.env.VUE_APP_PATH;
}
export const APP_API_BASE_URL = base_url + "/api/";
export const VUE_APP_API_BASE_URL = APP_API_BASE_URL + "ehospital";
export const WORKFLOW = base_url + "/api/workflow/";
export const APP_QUESTION_URL =
  base_url + "/front/mp-questionnaire/index.html#/questionnaire";
export const APP_ARTICLE_URL = base_url + "/front/article/#/newsDetail?id=";
export const uploadImgServer = APP_API_BASE_URL + "file/upload";

export const LOGIN_DIR = "https://prm.chinacaring.com/api/";
export const QUES_PATH = "https://prm.chinacaring.com/questionnaire/";
export const QUES_DIR = APP_API_BASE_URL + "questionnaire/";
export const Follow_PATH = APP_API_BASE_URL + "follow";
export const UPLOAD_EXCEL = APP_API_BASE_URL + "follow/task_info/import/";
export const CARINGFAST = APP_API_BASE_URL + "caring1/";
export const FAST_UPLOAD = APP_API_BASE_URL + "file/upload/";
export const USER_IMPORT = APP_API_BASE_URL + "/user/import";
export const DIAG_IMPORT = VUE_APP_API_BASE_URL + "/diag/import";
export const ADDRESS_EXCEL =
  "https://prm.chinacaring.com/api/caring1/%E5%8C%BB%E7%94%9F%E8%B4%A6%E5%8F%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls";

export const PREVIEWFJ = "https://preview.chinacaring.com/onlinePreview?url=";

export const DIAGNOSIS_EXCEL =
  "https://prm.chinacaring.com/api/caring1/%E8%AF%8A%E6%96%AD%E5%AF%BC%E5%85%A5.xlsx";
// 不需要带user_id
export const USER_INFO = "MB-USER_INFO";
export const ACCESS_TOKEN = "MB-ACCESS_TOKEN";
// 需要携带user_id
export const TENANT = "MB-USER_TENANT";
// 需要携带tenant
export const SHIFT_INFO = "MB-SHIFT_INFO";
export const SHIFT_LIST = "MB-SHIFT_LIST";
export const USER_STORAGE = "MB-USER_STORAGE";
export const ADDRESS_BOOK = "MB-ADDRESS_BOOK";
export const ADDRESS_BOOK_TIME = "MB-ADDRESS_BOOK_TIME";
export const IM_TOKEN = "MB-IM_TOKEN";
export const ROLE_LIST = "ROLE_LIST";
export const IS_PLATFORM = "IS_PLATFORM";
export const uploadNew = APP_API_BASE_URL + "questionnaire/excel/choice/import";

export const interfaceUrl =
  APP_API_BASE_URL + "questionnaire/interface/choice/import";
